// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { minusWide16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-minus-wide': IconMinusWide;
    }
}

/**
 * The icon component for the 'minusWide' icon
 */
export class IconMinusWide extends IconSvg {
    public constructor() {
        super(minusWide16X16);
    }
}

registerIconSvg('icon-minus-wide', IconMinusWide);
export const iconMinusWideTag = 'nimble-icon-minus-wide';
